import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./Redux/Store";
import { Provider } from "react-redux";
// import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
